import { useCallback } from 'react';

import type { GlobalApiErrorCode } from '@data/global-api-errors';
import { TOAST_VARIANT, useToast } from '@state/checkout-contexts';

import { ERROR_CODES_IN_TOAST } from '../../global.constants';

export const useHandleCommonErrors = () => {
  const { setToast } = useToast();

  const handleError = useCallback(
    (errorCode: GlobalApiErrorCode | string | null, message: string | null) => {
      if (
        errorCode &&
        ERROR_CODES_IN_TOAST.includes(errorCode as GlobalApiErrorCode)
      ) {
        message && setToast(message, TOAST_VARIANT.ERROR);
      }
    },
    [setToast]
  );

  return { handleError };
};
